import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-56d82fec")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { id: "form-body" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!
  const _component_Login = _resolveComponent("Login")!
  const _component_SignUp = _resolveComponent("SignUp")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.bounceTransition, "modal-body"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", {
            style: {"height":"30px","width":"30px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'login-signup-close' })
          ])
        ]),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.loginSelected)
            ? (_openBlock(), _createBlock(_component_Login, {
                key: 0,
                onSelectSignup: _ctx.selectSignup
              }, null, 8, ["onSelectSignup"]))
            : (_openBlock(), _createBlock(_component_SignUp, {
                key: 1,
                onSelectLogin: _ctx.selectLogin
              }, null, 8, ["onSelectLogin"]))
        ])
      ], 2)
    ], 2)
  ]))
}